import {
  Directive,
  ElementRef,
  Renderer2,
  OnInit,
  OnDestroy,
  AfterViewInit,
  RendererStyleFlags2,
  input,
} from '@angular/core';
import { Subject } from 'rxjs';

@Directive({
  selector: '[dynamicHeight]',
  standalone: false
})
export class DynamicHeightDirective
  implements OnInit, AfterViewInit, OnDestroy
{
  public offsetId =  input<string>('');
  public parentHeightPercentage =  input<number>(0.9);

  private destroy$ = new Subject<void>();

  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2,
  ) {}

  ngOnInit(): void {
    const observer = new MutationObserver(() => {
      this.setHeight();
    });

    observer.observe(this.el.nativeElement, {
      childList: true,
      subtree: true
    });
  }

  ngAfterViewInit(): void {
    // Initial height calculation after the view is initialized
    setTimeout(() => this.setHeight(), 0);
  }

  private setHeight(): void {
    const parentElement = this.el.nativeElement.parentElement;

    if (!parentElement) {
      return;
    }

    // Get parent height
    const parentHeight = parentElement.clientHeight;

    // Calculate height based on percentage of parent
    let calculatedHeight = parentHeight * this.parentHeightPercentage();

    if (this.offsetId()) {
      const offsetElement = document.getElementById(this.offsetId()) as HTMLElement | null;
      if(offsetElement instanceof HTMLElement){
        calculatedHeight = calculatedHeight - offsetElement.offsetHeight;
      }
    }
      

    this.renderer.setStyle(
      this.el.nativeElement,
      'height',
      `${calculatedHeight}px`,
      RendererStyleFlags2.Important
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}